module.exports = __webpack_public_path__ + "static/media/First5_Post03-Image.54a80781.jpg";